<script>
import resources from './resources'

export default {
  name: 'registration-me',
  mixins: [resources]
}
</script>

<template lang="pug">
  page(title="Meu Cadastro", icon="")
    .col-xs-12.content
      .container-fluid
        .row
          medibook-alert-custom(
            :show='show',
            @close='show = false',
            title='Perfeito',
            type='sa-success',
            message='Seu dados foram alterados com sucesso.',
            :buttonsNext='nextStepButtonIsProfessionalSpeciality',
            v-if="beenUpdated")

          .col-xs-12.white-bg
            .row
              .col-xs-12
                div.col-sm-12
                  .accordion.cadastro
                    .panel
                      h4.panel-title(data-toggle='collapse', data-target='.collapsible-1', data-parent='.cadastro', @click.preventt="collapsibleOne()")
                        |PERFIL PROFISSIONAL
                      .collapsible-1.collapse(:class="{'in' : setpTwocollapsibleOne}")
                        .panel-body
                          .col-xs-12.col-sm-3.margin-bottom
                              label(for='entidade') Entidade
                              .input-group
                                select#entidade.form-control(name='entidade', tabindex="1", disabled)
                                  option(value='crm') CRM
                                span.input-group-addon.blue-addon
                                  span.icon 

                          .col-xs-12.col-sm-3
                            v-input(:status="$v.registration.document.$error ? 'error' : null")
                              f-text(label="Número de Registro"
                                name="document",
                                v-model="registration.document",
                                :errors="errors['document']",
                                :disabled="true")

                          .col-xs-12.col-sm-3
                            v-input(:status="$v.registration.state.$error ? 'error' : null")
                              f-select-state(label="UF",
                               name="state",
                               v-model="registration.state",
                               :searchable="true",
                               :errors="errors['state']",
                               :disabled="true")

                          .col-xs-12.col-sm-3
                            label Data de Inscrição
                            v-datepicker(
                              v-model='registration.record',
                              :config='config')
                              .border-botton
                        .panel-body
                          .form-group.col-xs-12.col-sm-3.margin-bottom
                            label CPF
                            f-document(
                              name="country_register",
                              v-model="registration.country_register",
                              :errors="errors['country_register']")

                          .form-group.col-xs-12.col-sm-6.margin-bottom
                            v-input(:status="$v.registration.name.$error ? 'error' : null")
                              f-text(label="Nome Completo"
                                name="name",
                                v-model="registration.name",
                                :errors="errors['registration.name']")

                          .form-group.col-xs-12.col-sm-3.margin-bottom
                            v-input(:status="$v.registration.birthdate.$error ? 'error' : null")
                              label Data de Nascimento
                              v-datepicker(
                                name="birthdate",
                                v-model='registration.birthdate',
                                :config='config')
                        .painel-body
                          .form-group(style='margin-top:15px;')
                              .col-xs-12.col-sm-12.margin-bottom
                                f-text(label="Perfil LinkedIn",
                                 name="social",
                                 v-model="registration.networks.linkedin",
                                 :errors="errors['networks']",
                                 placeholder='http://www.linkedin.com')

                                f-text(label="Currículo Lattes"
                                  name="social",
                                  v-model="registration.networks.lattes",
                                  :errors="errors['networks']",
                                  placeholder='http://lattes.cnpq.br')

                                  //-- Removido devido ao novo modulo
                                  //--.row
                                    .col-xs-12.col-sm-12
                                      f-file-text(v-if="!registration.attachment.uuid", label="Anexar CRM"
                                       v-model="registration.attachment",
                                       name='attachment',
                                       :erro

                                br
                                button.btn.save.pull-right(@click.prevent="doSaveSetpOne()")
                                  span.icon 
                                  |  Salvar Alterações
                    .panel
                      h4.panel-title(data-toggle='collapse', data-target='.collapsible-3', data-parent='.cadastro', @click.prevent="collapsibleTwo()")
                        | INFORMAÇÕES COMPLEMENTARES
                      .collapsible-3.collapse(:class="{'in' : setpTwocollapsibleTwo}")
                        .panel-body3
                          .alert.alert-danger(style="color: red;")
                            i.fa.fa-info-circle(aria-hidden='true') &nbsp;&nbsp;
                            |Os dados das informações complementares serão exibidos junto ao perfil do prestador.
                          f-editor(v-model="registration.bio", placeholder="Informar sua biográfia")
                          br
                          button.btn.save.pull-right.btn-editor(@click.prevent="doSaveSetpTwo()")
                              span.icon 
                              |  Salvar Alterações
                          br
                    .panel
                      h4.panel-title(data-toggle='collapse', data-target='.collapsible-4', data-parent='.cadastro', @click.prevent="collapsibleThree()")
                        | PALAVRAS CHAVE
                      .collapsible-4.collapse(:class="{'in' : setpTwocollapsibleThree}")
                        .panel-body
                          .alert.alert-danger(style="color: red;")
                            i.fa.fa-info-circle(aria-hidden='true') &nbsp;&nbsp;
                            |Pressione &nbsp;
                            strong Enter &nbsp;
                            |para separar as palavras-chave.
                          tags()
</template>
<style scoped>
  .panel-body {
    padding: 0px;
  }
  .margin-top-50 {
    margin-top: 50px
   }
  .margin-bottom {
    margin-bottom: 30px;
  }

  @media screen and (max-width: 767px){
    .btn-editor {
      padding: 6px 2%;
      width: 98%;
      margin: 45px 0px;
  }
  }
</style>



// WEBPACK FOOTER //
// src/app/professional/record/registration/me.vue